import Row from '@components/Row';
import { OptionGroup } from '@models/item';

import OptionItem from './OptionItem';
import styles from './styles.module.scss';

interface Props {
    optionGroup: OptionGroup;
    itemId: string;
}

function IconOption({ optionGroup, itemId }:Props) {
  const { options, optionGroupId } = optionGroup;
  return (
      <div className={styles.container}>
          <Row justify='center'
               align='flex-start'
               className={styles.options}
               spacing={46}
               fullWidth>
              {options.map((option) => (
                  <OptionItem option={option}
                              itemId={itemId}
                              optionGroupId={optionGroupId}
                              key={option.optionId}/>
              ))}
          </Row>
      </div>
  );
}

export default IconOption;
